export enum UserAdminState {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  INVITED = 'invited',
}
